/**
  Back to Top Component
  <back-to-top>
    <button class="back-to-top button button--primary" js-top-button><span>{% render 'icon-caret'%}</span></button>
  </back-to-top>

  Style placement of button by using section selector i.e. '.collage-grid back-to-top{}'
*/

class BackToTop extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      button: '[js-top-button]'
    }
  }

  connectedCallback() {
    this.button = this.querySelector(this.selectors.button)
    this._setEventListeners();
  }

  _setEventListeners() {
    this.button.addEventListener("click", this._backToTop)
  }

  _backToTop(){
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
}

customElements.define("back-to-top", BackToTop);